import "./Seo.scss";

import React from "react";
import { getContentHubDamAsset } from '../../utils/get-contenthub-dam-asset';
import { SEO } from "../../models/app-data-model";
import { jsonValidator } from "../../services/json-validator";

export type SeoProps = {
  content: SEO;
};

const Seo: React.FC<SeoProps> = (props: SeoProps) => {


  const pageLocale = props.content.locale || props.content.defaultLocale;
  const pageUrl = `${props.content.siteUrl}${props.content.pagePath}`;
  const pageTitle = props.content.title;

  const contenthubDamAsset = getContentHubDamAsset(props.content.contenthub_asset, undefined);
  const pageAuthorUrl = props.content.authorUrl || props.content.defaultAuthorUrl;
  const pagePublisherUrl = props.content.publisherUrl || props.content.defaultPublisherUrl;
  
  let keywordsStr;
  if (props.content.keywords && typeof props.content.keywords === 'string') {
    keywordsStr = props.content.keywords.trim();
  }
  if (props.content.keywords && Array.isArray(props.content.keywords)) {
    keywordsStr = props.content.keywords.join(', ').trim();
  }
  
  const hasSchema = !!props.content.globalSchema || !!props.content.schema;

  let schemaJson;
  if (hasSchema) {
    schemaJson = `
    { "@context": "https://schema.org",
      "@graph": [
      ${props.content.globalSchema || ''}${props.content.globalSchema && props.content.schema ? ',' : ''}${props.content.schema || ''}
      ]
    }`;
    if (!jsonValidator(schemaJson)) {
      throw Error("Invalid JSON Schema. Check the values of 'globalSchema' in gatsby-config.js, or 'schema' prop of the page");
    }
  }
  return(
    <>
      {/* Icons */}
      <link rel="apple-touch-icon" sizes="180x180" href={props.content.appleTouch} />
      <link rel="icon" type="image/png" href={props.content.favicon32} sizes="32x32" />
      <link rel="icon" type="image/png" href={props.content.favicon16} sizes="16x16" />
      <link rel="icon" type="image/png" href="https://priorityhealth.stylelabs.cloud/api/public/content/66d0df7cd869473398163582254cd7a0?v=8c38a076&amp;t=compressor"></link>
      <link rel="shortcut icon" href="/favicon.png" />
      
      {/* Core  */}
      <title>{pageTitle} {pageTitle &&  " | "} {"Priority Health"}</title>
      <meta name="description" content={props.content.description} />
      {keywordsStr && <meta name="keywords" content={keywordsStr} />}

      {/* For PHDOTCOM site search to find each term individually*/}
      {keywordsStr && keywordsStr.split(',').map((keyword, index) => <meta name="keyword" content={keyword} key={index} />)}

      {/* For Facebook domain verification */}
      {props.content.facebookDomainVerification && <meta name="facebook-domain-verification" content={props.content.facebookDomainVerification} />}

      {/* OG */}
      <meta property="og:url" content={pageUrl} />
      <meta property="og:type" content={props.content.ogType || 'website'} />
      <meta property="og:title" content={props.content.title} />
      <meta property="og:description" content={props.content.description} />
      <meta property="og:locale" content={pageLocale} />
      <meta property="og:site_name" content={props.content.siteName} />

      {/* Images */}
      {/* {pageImage && <meta property="og:image" content={new URL(pageImage, props.content.siteUrl).toString()} />}*/ }  
      {contenthubDamAsset && <meta property="og:image" content={contenthubDamAsset.url} />}
      {contenthubDamAsset && <meta property="og:image:secure_url" content={new URL(contenthubDamAsset.url, props.content.siteUrl).toString()} />}

      {/* Article */}
      {props.content.ogType === 'article' && pagePublisherUrl && <meta property="article:publisher" content={pagePublisherUrl} />}
      {props.content.ogType === 'article' && pageAuthorUrl && <meta property="article:author" content={pageAuthorUrl} />}

      {/* Twitter */}
      <meta name="twitter:card" content={props.content.twitterCard} />
      {props.content.twitterSite && <meta name="twitter:site" content={props.content.twitterSite} />}
      {props.content.twitterCreator && <meta name="twitter:creator" content={props.content.twitterCreator} />}
      {hasSchema && (
        <script defer async type="application/ld+json">
          {schemaJson}
        </script>
      )}

      {/* Prevents most search engine web crawlers from indexing the page */}
      {props.content.noIndex && <meta name="robots" content="noindex" />}
     
    </>
  );       
};

export default Seo;
